/* ============================================================================
   SDA cart extras: nivåstapeln (fri frakt + up to two gifts), the automatic
   gift lines and meddelanderutan (the order note).

   - Config: snippets/sda-cart-extras.liquid (#sda-cart-extras-config).
   - The theme fires no "cart changed" event, so the cart JSON is read from the
     theme's own /cart.js and /cart/change.js responses (fetch wrapper below).
   - The bar is drawn here only, for the drawer (inside its <template>, before
     the first open) and for /cart.
   - Gift lines carry the hidden property _sda_gift = tier key ("g1", "g2").
     cart-line-items.liquid labels them; the cart hides "_" properties.
   - Gifts are only added or removed while the drawer is open (or on /cart), so
     a sync never pops the drawer open. The theme re-renders the lines through
     window.cart.getCart().
   - A gift line must be made free by an automatic discount. If it is not, it is
     removed and the tier is switched off for the session (unless testMode).
     Shopify frees the cheapest items of a gift pool first, and at the same price
     the line highest up in the cart, so an item the customer bought from the
     pool can take the free unit instead (see plan()).
   ============================================================================ */
(function () {
  if (window.__sdaCartExtras) return;
  window.__sdaCartExtras = true;

  var configEl = document.getElementById('sda-cart-extras-config');
  if (!configEl || !window.fetch) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var tiers = config.tiers || [];
  var gifts = tiers.filter(function (tier) { return tier.gift; });
  // Every variant a gift discount can make free, all gift tiers together.
  var pool = [];
  gifts.forEach(function (tier) { pool = pool.concat(tier.pool || []); });
  // Test mode never applies on the published theme, whatever its settings say.
  var testMode = Boolean(config.testMode) && !(window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main');
  // "Bygg ditt 3-pack" (Theme settings → SDA varukorg → 3-pack): Shopify won't let a gift discount
  // count items that already carry another product discount, so with a 3-pack in the cart the gifts
  // count the other items only.
  var threepack = config.threepack || null;
  var root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
  var rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
  var baseFetch = window.fetch.bind(window);

  var cartRequest = /\/cart(\.js|\/(add|change|update|clear)(\.js)?|\?)/;
  var cartJson = /\/cart(\.js|\/(change|update|clear)\.js)(\?|$)/;
  var cartMutation = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var current = config.cart || null;
  var inflight = 0;
  var lastCartAt = 0;
  var syncTimer = 0;
  var syncing = false;
  var stale = false;
  var waits = 0;
  var attempts = {};
  var swapped = {};
  var memory = {};
  var uid = 0;

  var icons = {
    ship: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6.5h11v10h-11zM13.5 10h4.2l3.3 3.4v3.1h-7.5"/><circle cx="6.5" cy="17.5" r="1.7"/><circle cx="17" cy="17.5" r="1.7"/></svg>',
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 11.5h15v9h-15zM3 7.5h18v4H3zM12 7.5v13"/><path d="M12 7.5C10.8 4.6 7.2 4 7.2 6c0 1.4 2.3 1.5 4.8 1.5zM12 7.5c1.2-2.9 4.8-3.5 4.8-1.5 0 1.4-2.3 1.5-4.8 1.5z"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>'
  };

  /* -- Helpers --------------------------------------------------------------- */
  function cents(amount) {
    return Math.round(amount * 100 * rate);
  }

  function money(value) {
    var text;
    try {
      text = window.slate.Currency.formatMoney(value, window.theme.moneyFormat);
    } catch (e) {
      text = Math.round(value / 100) + ' kr';
    }
    // Drop zero decimals only ("1,000 kr" must keep its thousands).
    return String(text).replace(/[.,]00(?=\D*$)/, '');
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function giftKey(item) {
    return (item && item.properties && item.properties._sda_gift) || '';
  }

  function linesOf(cart, tier) {
    return (cart.items || []).filter(function (item) { return giftKey(item) === tier.key; });
  }

  function hasGiftLines(cart) {
    return Boolean(cart && (cart.items || []).some(giftKey));
  }

  function inPool(item) {
    return pool.indexOf(item.variant_id) !== -1;
  }

  function unitPrice(item) {
    return item.original_line_price / Math.max(1, item.quantity);
  }

  // The amount a "100 % off" discount took off a line, which is what a gift discount does.
  function freed(item) {
    var total = 0;
    (item.line_level_discount_allocations || []).forEach(function (allocation) {
      var application = allocation.discount_application || {};
      if (application.value_type === 'percentage' && Number(application.value) >= 100) total += allocation.amount;
    });
    return total;
  }

  // A line the 3-pack discount covers, by the builder page's rule (sections/sda-3pack-builder.liquid):
  // a single-pack supplement bought once, not a bundle or Buffé.
  function inThreepack(item) {
    if (giftKey(item) || item.selling_plan_allocation) return false;
    var type = item.product_type || '';
    if (type.indexOf(threepack.type) === -1 || threepack.exclude.indexOf(type) !== -1) return false;
    if (String(item.handle || '').indexOf('-x-3') !== -1) return false;
    return String(item.variant_title || '').toLowerCase().replace(/\s/g, '').indexOf('x3') === -1;
  }

  // The 3-pack lines once there are three units (the discount's minimum), else none.
  function threepackLines(cart) {
    if (!threepack) return [];
    var lines = (cart.items || []).filter(inThreepack);
    var units = lines.reduce(function (sum, item) { return sum + item.quantity; }, 0);
    return units >= threepack.min ? lines : [];
  }

  // What counts toward a tier, gift lines never included. Gifts count the items
  // before order-level codes (QUIZ15), which is what the Buy X get Y discount checks;
  // fri frakt counts the total after them, as the theme always did. Without an order
  // code the two are the same. If the discount freed the customer's own Buffé instead
  // of the gift line, it counts as if the gift line were the free one. With a 3-pack,
  // its lines don't count toward the gifts.
  function measures(cart) {
    var giftTotal = 0;
    var credit = 0;
    var threepackTotal = 0;
    (cart.items || []).forEach(function (item) {
      if (giftKey(item)) giftTotal += item.final_line_price;
      else if (inPool(item)) credit += freed(item);
    });
    var packLines = threepackLines(cart);
    packLines.forEach(function (item) { threepackTotal += item.final_line_price; });
    credit = Math.min(credit, giftTotal);
    var items = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    return {
      ship: Math.max(0, (cart.total_price || 0) - giftTotal + credit),
      gift: Math.max(0, (items || 0) - giftTotal + credit - threepackTotal),
      threepack: packLines.length > 0
    };
  }

  function valueOf(tier, m) {
    return tier.gift ? m.gift : m.ship;
  }

  function reachedTier(tier, m) {
    return valueOf(tier, m) >= cents(tier.amount);
  }

  function getFlag(name, key) {
    var id = 'sda-gift-' + name + ':' + key;
    if (memory[id]) return true;
    try {
      return window.sessionStorage.getItem(id) === '1';
    } catch (e) {
      return false;
    }
  }

  function setFlag(name, key, on) {
    var id = 'sda-gift-' + name + ':' + key;
    memory[id] = on;
    try {
      if (on) window.sessionStorage.setItem(id, '1');
      else window.sessionStorage.removeItem(id);
    } catch (e) {}
  }

  function post(path, body) {
    return baseFetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok) {
          var error = json || {};
          error.httpStatus = response.status;
          throw error;
        }
        return json;
      });
    });
  }

  function readCart() {
    return baseFetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(onCart)
      .catch(function () {});
  }

  /* -- Nivåstapeln ----------------------------------------------------------- */
  // Tiers grouped by amount. A shared step (fri frakt + gåva 1 at 299 kr) takes
  // its copy from the gift and joins the labels. A gift switched off for the
  // session (no discount made it free) leaves the bar, so it never promises it.
  function activeSteps() {
    var steps = [];
    tiers.filter(function (tier) { return !tier.gift || !getFlag('off', tier.key); })
      .sort(function (a, b) { return a.amount - b.amount; })
      .forEach(function (tier) {
        var last = steps[steps.length - 1];
        if (last && last.amount === tier.amount) last.tiers.push(tier);
        else steps.push({ amount: tier.amount, tiers: [tier] });
      });
    steps.forEach(function (step) {
      var giftTiers = step.tiers.filter(function (tier) { return tier.gift; });
      step.gift = giftTiers.length > 0;
      step.lead = step.gift ? giftTiers[giftTiers.length - 1] : step.tiers[0];
      step.label = step.tiers.map(function (tier) { return tier.label; }).filter(Boolean).join(' + ');
    });
    return steps;
  }

  // With a 3-pack, a step that has fri frakt stands for fri frakt alone: its gift counts the
  // other items and the headline speaks for it.
  function stepTiers(step, three) {
    var ship = step.tiers.filter(function (tier) { return !tier.gift; });
    return three && ship.length ? ship : step.tiers;
  }

  function stepLabel(step, three) {
    return stepTiers(step, three).map(function (tier) { return tier.label; }).filter(Boolean).join(' + ');
  }

  function skeleton(steps, three) {
    var top = steps[steps.length - 1].amount;
    var markers = '';
    var labels = '';
    var id = 'sda-tiers-headline-' + (++uid);
    // The bar's name is its steps ("Fri frakt + Buffé, Godispåse"), its value the headline.
    var name = steps.map(function (step) { return stepLabel(step, three); }).filter(Boolean).join(', ');

    steps.forEach(function (step, index) {
      var position = top > 0 ? (step.amount / top) * 100 : 100;
      var align = position <= 12 ? ' is-start' : (position >= 88 ? ' is-end' : '');
      markers += '<span class="sda-tiers__step" data-sda-step="' + index + '" style="left:' + position + '%"></span>';
      labels += '<li class="sda-tiers__label' + align + '" data-sda-step-label="' + index + '" style="left:' + position + '%">' +
        '<strong>' + escapeHtml(stepLabel(step, three)) + '</strong>' + escapeHtml(money(cents(step.amount))) + '</li>';
    });

    return '<p class="sda-tiers__headline" id="' + id + '" data-sda-tiers-headline aria-live="polite"></p>' +
      '<div class="sda-tiers__track">' +
        '<div class="sda-tiers__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" ' +
          (name ? 'aria-label="' + escapeHtml(name) + '"' : 'aria-labelledby="' + id + '"') + ' data-sda-tiers-bar>' +
          '<span class="sda-tiers__fill" data-sda-tiers-fill></span>' +
        '</div>' +
        markers +
      '</div>' +
      '<ol class="sda-tiers__labels">' + labels + '</ol>' +
      '<button type="button" class="sda-tiers__readd" data-sda-gift-readd hidden>' + escapeHtml(config.readd) + '</button>';
  }

  // The done text of the highest step with no removed gift at or below it: a step's
  // text speaks for the gifts before it too ("två gåvor"). If the first gift is gone,
  // fall back to the shipping text ("✓ Du har fri frakt").
  function doneText(steps, cart) {
    function removed(tier) {
      return tier.gift && getFlag('declined', tier.key) && !linesOf(cart, tier).length;
    }
    for (var i = steps.length - 1; i >= 0; i--) {
      var clean = steps.slice(0, i + 1).every(function (step) { return !step.tiers.some(removed); });
      if (clean) return steps[i].lead.done;
    }
    var ship = tiers.filter(function (tier) { return !tier.gift; })[0];
    return ship ? ship.done : '';
  }

  function declinedGifts(cart, m) {
    return gifts.filter(function (tier) {
      return reachedTier(tier, m) && getFlag('declined', tier.key) && !getFlag('off', tier.key) && !linesOf(cart, tier).length;
    });
  }

  function draw(el, cart) {
    var steps = activeSteps();
    if (!steps.length || !cart || !cart.item_count) {
      el.hidden = true;
      return;
    }
    var m = measures(cart);
    var signature = (m.threepack ? '3pack|' : '') + steps.map(function (step) {
      return step.amount + ':' + step.tiers.map(function (tier) { return tier.key; }).join('+');
    }).join('|');
    if (el.getAttribute('data-sda-signature') !== signature || !el.querySelector('[data-sda-tiers-bar]')) {
      el.innerHTML = skeleton(steps, m.threepack);
      el.setAttribute('data-sda-signature', signature);
    }
    el.hidden = false;

    var last = steps[steps.length - 1];
    var next = null;
    var pending = [];
    for (var i = 0; i < steps.length; i++) {
      pending = steps[i].tiers.filter(function (tier) { return !reachedTier(tier, m); });
      if (pending.length) {
        next = steps[i];
        break;
      }
    }

    var headline;
    if (next) {
      // The whole step still to go: its own copy. Only part of it (an order code put
      // fri frakt out of reach while the gift is there): that part's copy.
      var pendingGifts = pending.filter(function (tier) { return tier.gift; });
      var lead = pending.length === next.tiers.length ? next.lead : (pendingGifts[pendingGifts.length - 1] || pending[0]);
      var message = lead.message;
      if (m.threepack) {
        // With a 3-pack, fri frakt and the gifts count different amounts: fri frakt first,
        // then the 3-pack copy, which says the gifts count the other items.
        var shipTier = pending.filter(function (tier) { return !tier.gift; })[0];
        lead = shipTier || pendingGifts[pendingGifts.length - 1];
        message = shipTier ? shipTier.message : (threepack.message || lead.message);
        pending = [lead];
      }
      var missing = Math.max.apply(null, pending.map(function (tier) { return cents(tier.amount) - valueOf(tier, m); }));
      headline = escapeHtml(message).split('||amount||').join('<strong>' + escapeHtml(money(missing)) + '</strong>');
    } else {
      headline = escapeHtml(doneText(steps, cart));
    }
    var reachedSteps = steps.map(function (step) {
      return stepTiers(step, m.threepack).every(function (tier) { return reachedTier(tier, m); });
    });
    var percent = Math.min(100, (valueOf(last.lead, m) / Math.max(1, cents(last.amount))) * 100);
    if (m.threepack) {
      // The gifts count the other items, so fri frakt reached by the 3-pack still fills to its marker.
      steps.forEach(function (step, index) {
        if (reachedSteps[index]) percent = Math.max(percent, Math.min(100, (step.amount / Math.max(1, last.amount)) * 100));
      });
    }

    var headlineEl = el.querySelector('[data-sda-tiers-headline]');
    if (headlineEl.__sdaHtml !== headline) {
      headlineEl.innerHTML = headline;
      headlineEl.__sdaHtml = headline;
    }

    var bar = el.querySelector('[data-sda-tiers-bar]');
    bar.setAttribute('aria-valuenow', String(Math.round(percent)));
    bar.setAttribute('aria-valuetext', headlineEl.textContent);
    el.querySelector('[data-sda-tiers-fill]').style.width = percent + '%';

    steps.forEach(function (step, index) {
      var reached = reachedSteps[index];
      var shownGift = stepTiers(step, m.threepack).some(function (tier) { return tier.gift; });
      var icon = reached ? 'check' : (shownGift ? 'gift' : 'ship');
      var marker = el.querySelector('[data-sda-step="' + index + '"]');
      var label = el.querySelector('[data-sda-step-label="' + index + '"]');

      if (marker) {
        if (marker.getAttribute('data-icon') !== icon) {
          marker.innerHTML = icons[icon];
          marker.setAttribute('data-icon', icon);
        }
        marker.classList.toggle('is-reached', reached);
      }
      if (label) label.classList.toggle('is-reached', reached);
    });

    var readd = el.querySelector('[data-sda-gift-readd]');
    if (readd) readd.hidden = declinedGifts(cart, m).length === 0;
  }

  // Bars in the page plus the one inside the drawer <template>, so the first
  // open of the drawer already shows the current state.
  function bars() {
    var list = Array.prototype.slice.call(document.querySelectorAll('[data-sda-tiers]'));
    var template = document.querySelector('[data-cart-drawer-template]');
    if (template && template.content) {
      list = list.concat(Array.prototype.slice.call(template.content.querySelectorAll('[data-sda-tiers]')));
    }
    return list;
  }

  function drawAll() {
    if (!current) return;
    bars().forEach(function (el) { draw(el, current); });
  }

  /* -- Meddelanderutan ------------------------------------------------------- */
  var noteTimer = 0;
  var savedNote = null;

  function showNotes() {
    if (!current) return;
    var wraps = document.querySelectorAll('[data-sda-note-wrap]');
    for (var i = 0; i < wraps.length; i++) wraps[i].hidden = !current.item_count;
  }

  function saveNote(value) {
    if (value === savedNote) return;
    savedNote = value;
    post('cart/update.js', { note: value }).catch(function () { savedNote = null; });
  }

  function noteField(event) {
    return event.target && event.target.closest ? event.target.closest('[data-sda-note]') : null;
  }

  document.addEventListener('input', function (event) {
    var field = noteField(event);
    if (!field) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { saveNote(field.value); }, 600);
  });

  document.addEventListener('change', function (event) {
    var field = noteField(event);
    if (!field) return;
    clearTimeout(noteTimer);
    saveNote(field.value);
  });

  /* -- Gift lines ------------------------------------------------------------ */
  // The customer's own lines from a gift pool that a gift discount made free.
  function ownFreed(cart) {
    return (cart.items || []).filter(function (item) {
      return !giftKey(item) && inPool(item) && freed(item) > 0;
    });
  }

  function plan(cart) {
    var m = measures(cart);
    var own = ownFreed(cart);
    var ops = [];

    // Gift lines of a tier that has left the config (switched off, nothing in stock).
    (cart.items || []).forEach(function (item) {
      var key = giftKey(item);
      if (key && !gifts.some(function (tier) { return tier.key === key; })) ops.push({ key: item.key, quantity: 0 });
    });

    var states = gifts.map(function (tier) {
      var lines = linesOf(cart, tier);
      var price = lines.length ? unitPrice(lines[0]) : tier.price;
      return {
        tier: tier,
        lines: lines,
        wanted: reachedTier(tier, m) && !getFlag('off', tier.key),
        // A cheaper item of the customer's own holds the free unit: the 1000 kr discount frees
        // the two cheapest, so a RAUH! they bought beats the Buffé gift. The gift stays out
        // while that holds; nothing is switched off.
        displaced: own.some(function (item) { return unitPrice(item) < price; })
      };
    });
    // The 1000 kr discount frees the gifts only when both lines are in the cart, so while a
    // gift is still to be added, the others are not judged yet.
    var adding = states.some(function (state) {
      return state.wanted && !state.lines.length && !state.displaced && !getFlag('declined', state.tier.key);
    });

    states.forEach(function (state) {
      var tier = state.tier;
      var lines = state.lines;
      var line = lines[0];

      if (!state.wanted) {
        lines.forEach(function (item) { ops.push({ key: item.key, quantity: 0 }); });
        if (!lines.length) attempts[tier.key] = 0;
        return;
      }

      // One line of one first; the next round judges it.
      if (lines.length > 1 || (line && line.quantity !== 1)) {
        lines.forEach(function (item, index) {
          if (index > 0) ops.push({ key: item.key, quantity: 0 });
          else if (item.quantity !== 1) ops.push({ key: item.key, quantity: 1 });
        });
        return;
      }

      if (!line) {
        if (!state.displaced && !getFlag('declined', tier.key)) ops.push({ add: tier });
        return;
      }

      var price = unitPrice(line);
      if (line.final_line_price === 0) {
        swapped[tier.key] = false;
      } else if (!adding) {
        // At the same price Shopify frees the line highest up in the cart, the newest. If the
        // customer's own Buffé got it, add the gift again once. After that the total is the same.
        var tie = own.some(function (item) { return unitPrice(item) === price; });
        if (tie && !swapped[tier.key]) {
          swapped[tier.key] = true;
          ops.push({ key: line.key, quantity: 0 }, { add: tier });
          return;
        }
        if (!tie && state.displaced) {
          ops.push({ key: line.key, quantity: 0 });
          return;
        }
        if (!tie && !testMode) {
          setFlag('off', tier.key, true);
          if (window.console && console.warn) {
            console.warn('[SDA] Gift ' + tier.key + ' is not free in the cart. Is its automatic discount active? Removed for this session.');
          }
          ops.push({ key: line.key, quantity: 0 });
          return;
        }
      }

      attempts[tier.key] = 0;
    });

    return ops;
  }

  // Adds the first in-stock variant. Only a sold-out answer (422) falls through to the
  // next flavour; a network error or rate limit waits for the next sync instead.
  function addGift(tier) {
    attempts[tier.key] = (attempts[tier.key] || 0) + 1;
    if (attempts[tier.key] > 2) {
      setFlag('off', tier.key, true);
      return Promise.resolve();
    }

    var candidates = (tier.variants || []).slice();
    function tryNext() {
      var id = candidates.shift();
      if (!id) {
        setFlag('off', tier.key, true);
        return Promise.resolve();
      }
      return post('cart/add.js', { items: [{ id: id, quantity: 1, properties: { _sda_gift: tier.key } }] }).catch(function (error) {
        if (error && error.httpStatus === 422) return tryNext();
      });
    }
    return tryNext();
  }

  function apply(op) {
    if (op.add) return addGift(op.add);
    return post('cart/change.js', { id: op.key, quantity: op.quantity }).catch(function () {});
  }

  function canSync() {
    var drawer = window.cart;
    return Boolean(drawer && (drawer.isCartPage || drawer.isCartDrawerOpen));
  }

  function scheduleSync(delay) {
    if (!gifts.length && !hasGiftLines(current)) return;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, delay == null ? 250 : delay);
  }

  // getCart() draws the lines again and always opens the drawer. If the customer closed
  // it meanwhile, only read the cart now and draw on the next open.
  function refresh() {
    var drawer = window.cart;
    if (drawer && typeof drawer.getCart === 'function') {
      if (drawer.isCartPage || drawer.isCartDrawerOpen) {
        drawer.getCart();
        return;
      }
      stale = true;
    }
    readCart();
  }

  function sync() {
    if (!current) return;
    if (!window.cart) {
      if (waits++ < 20) scheduleSync(250);
      return;
    }
    if (!canSync()) return;
    // Never interleave with the theme's own cart requests.
    if (syncing || inflight > 0) {
      scheduleSync(300);
      return;
    }

    var ops = plan(current);
    if (!ops.length) return;

    syncing = true;
    // The theme's loading state: the quantity buttons wait until getCart() has drawn the lines.
    if (typeof window.cart.addLoadingClass === 'function') window.cart.addLoadingClass();
    ops.reduce(function (chain, op) {
      return chain.then(function () { return apply(op); });
    }, Promise.resolve()).then(function () {
      syncing = false;
      refresh();
    });
  }

  function onCart(cart) {
    if (!cart || !cart.items) return;
    current = cart;
    lastCartAt = Date.now();
    if (!cart.item_count) {
      gifts.forEach(function (tier) { setFlag('declined', tier.key, false); });
    }
    drawAll();
    showNotes();
    scheduleSync();
  }

  // Apps that change the cart without a /cart.js read: read it ourselves.
  function afterMutation() {
    var at = Date.now();
    setTimeout(function () {
      if (lastCartAt < at) readCart();
    }, 900);
  }

  /* -- Watch the theme's cart requests --------------------------------------- */
  window.fetch = function (input) {
    var url = '';
    try {
      url = typeof input === 'string' ? input : (input && input.url) || String(input);
    } catch (e) {}

    var request = baseFetch.apply(null, arguments);
    if (!cartRequest.test(url)) return request;

    inflight++;
    request.then(function (response) {
      inflight = Math.max(0, inflight - 1);
      if (!response || !response.ok) return;
      if (cartJson.test(url)) {
        response.clone().json().then(onCart).catch(function () {});
      } else if (cartMutation.test(url)) {
        afterMutation();
      }
    }, function () {
      inflight = Math.max(0, inflight - 1);
    });
    return request;
  };

  try {
    var xhrOpen = XMLHttpRequest.prototype.open;
    var xhrSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__sdaCartXhr = cartMutation.test(String(url || ''));
      return xhrOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (xhr.__sdaCartXhr) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300) afterMutation();
        });
      }
      return xhrSend.apply(this, arguments);
    };
  } catch (e) {}

  /* -- Customer actions ------------------------------------------------------ */
  var checkoutButton = null;

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    // For browsers without event.submitter (the /cart checkout below).
    checkoutButton = target.closest('[name="checkout"]');

    // Also retries tiers switched off this session: the 1000 kr discount gives both
    // gifts only when both lines are in the cart, so removing one can turn the other off.
    if (target.closest('[data-sda-gift-readd]')) {
      gifts.forEach(function (tier) {
        setFlag('declined', tier.key, false);
        setFlag('off', tier.key, false);
      });
      attempts = {};
      swapped = {};
      scheduleSync(0);
      return;
    }

    // Runs before the theme's remove handler: a gift the customer removes stays removed.
    var remove = target.closest('[data-sda-gift-remove]');
    if (remove) setFlag('declined', remove.getAttribute('data-sda-gift-remove'), true);
  }, true);

  // "Till kassan" on /cart posts the page form, whose quantity fields go by position
  // (updates[]). A gift line added or removed meanwhile makes Shopify answer "Varukorgen
  // har ändrats". The theme saves every quantity through Ajax already, so checkout goes
  // without them and takes the cart as it is.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    var submitter = event.submitter || checkoutButton;
    checkoutButton = null;
    if (event.defaultPrevented || !form || !form.matches || !form.matches('[data-cart-form]')) return;
    if (!submitter || submitter.name !== 'checkout' || !form.contains(submitter)) return;
    var fields = form.querySelectorAll('[data-quantity-field][name]');
    for (var i = 0; i < fields.length; i++) fields[i].removeAttribute('name');
  });

  /* -- Init ------------------------------------------------------------------ */
  function init() {
    drawAll();
    showNotes();
    scheduleSync(400); // /cart only; the drawer syncs on theme:cart:open
  }

  document.addEventListener('theme:cart:loaded', function () {
    drawAll();
    showNotes();
  });
  // A sync that ended while the drawer was closed draws the lines now. The theme marks the
  // drawer open right after this event, so getCart() only draws.
  document.addEventListener('theme:cart:open', function () {
    if (stale && window.cart && typeof window.cart.getCart === 'function') {
      stale = false;
      window.cart.getCart();
    } else if (gifts.length || hasGiftLines(current)) {
      readCart();
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
